var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"subtitle-1 mt-5"},[_vm._v(_vm._s(_vm.$t("instructions.addFile")))]),_c('input',{staticClass:"mt-2",attrs:{"type":"file","accept":".pdf,.doc,.docx,.odt,.rtf,.txt,.xls,.xlsx,.ods,.csv,.ppt,.pptx,.odp,.png,.jpg,.jpeg,.gif,.webp,.mp4,.mkv,.mov,.avi,.webm"},on:{"change":_vm.handleImage}})])
}
var staticRenderFns = []

export { render, staticRenderFns }